document.addEventListener('DOMContentLoaded', function () {
  const headers = document.querySelectorAll('.main-article-content h2');
  if (headers.length > 0) {
    document.querySelector('.main-article-list').style.display = 'block';
  }
  window.onload = function () {
    var toc = '';
    var level = 0;

    document.getElementById('blogcontents').innerHTML = document
      .getElementById('blogcontents')
      .innerHTML.replace(
        /<h([\d])>([^<]+)<\/h([\d])>/gi,
        function (str, openLevel, titleText, closeLevel) {
          if (openLevel != closeLevel) {
            return str;
          }

          if (openLevel > level) {
            toc += new Array(openLevel - level + 1).join('<ul>');
          } else if (openLevel < level) {
            toc += new Array(level - openLevel + 1).join('</ul>');
          }

          level = parseInt(openLevel);

          var anchor = titleText.replace(/ /g, '_');
          toc += '<li><a href="#' + anchor + '">' + titleText + '</a></li>';

          return (
            '<h' +
            openLevel +
            '><a name="' +
            anchor +
            '">' +
            titleText +
            '</a></h' +
            closeLevel +
            '>'
          );
        }
      );

    if (level) {
      toc += new Array(level + 1).join('</ul>');
    }

    const t = document.getElementById('blogtoc');
    if (t) t.innerHTML += toc;
  };
});
